/**
 * Shared server transport boundary. Browser calls always stay same-origin.
 * Internal origins never become client-visible configuration.
 */
export function getApiBaseUrl(): string {
  if (typeof window !== "undefined") return "/api/platform"
  const candidate = process.env.GATEWAY_INTERNAL_URL
    || process.env.BACKEND_INTERNAL_URL
    || "http://127.0.0.1:8080"
  return validatedServerOrigin(candidate)
}

/** Opaque session storage is Platform-owned and retains backend-first routing. */
export function getPlatformSessionApiBaseUrl(): string {
  if (typeof window !== "undefined") throw new Error("Platform session transport is server-only")
  return validatedServerOrigin(process.env.BACKEND_INTERNAL_URL || process.env.GATEWAY_INTERNAL_URL || "http://127.0.0.1:8080")
}

function validatedServerOrigin(candidate: string): string {
  let url: URL
  try { url = new URL(candidate) } catch { throw new Error("Invalid server API origin") }
  if (!["http:", "https:"].includes(url.protocol) || url.username || url.password || url.search || url.hash || url.pathname !== "/") {
    throw new Error("Invalid server API origin")
  }
  return url.origin
}
